import styles from './userLink.module.scss';

/** A user's page, or one of its tabs ("kyc-status", "wallet-settings"). */
export const userHref = (userId, tab) =>
  `/dashboard/user/${userId}${tab ? `/${tab}` : ''}`;

/**
 * A user's name in a table, opening their page in a new tab.
 *
 * A new tab keeps the list, its filters and its page where they were. A real
 * anchor rather than a click handler also gives middle-click, cmd-click and
 * "copy link address". The click stops at the link, so a row that opens
 * something on click doesn't open it as well.
 *
 * Without a user id there is nowhere to go, so the name shows as plain text.
 */
const UserLink = ({userId, tab, children, className}) => {
  const label = children || '-';
  if (!userId) return label;

  return (
    <a
      className={className || styles.userLink}
      href={userHref(userId, tab)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={event => event.stopPropagation()}>
      {label}
    </a>
  );
};

export default UserLink;
